import React from 'react';
import { useParsedSearchParams } from '../../../lib/util';
import FlocPage from '../Floc/FlocPage';
import Layout from '../../templates/Layout';
import FlocSearch from '../../organisms/FlocSearch/FlocSearch';
import NoticeBarProvider from '../../molecules/NoticeBar/NoticeBar';

const Materials: React.FC = () => {
  const [asset] = useParsedSearchParams('asset');
  const [floc, setFloc] = useParsedSearchParams('floc');

  return (
    <Layout>
      <FlocSearch floc={floc} setFloc={setFloc} />
      <NoticeBarProvider>{asset && floc ? <FlocPage /> : ""}</NoticeBarProvider>
    </Layout>
  );
};

export default Materials;
